import resourceType from "src/models/resourceType"
import { Model, Schema } from "src/engine/modules/model/classes"
import { denormalizeResource } from "src/models/resource"
import memoize from "lodash/memoize"

const entityName = `planResources`

export default memoize(
  planId =>
    new Model({
      name: entityName,
      getRestUrn: () => `/plans/${planId}/resources`,
      primaryKey: `uuid`,
      denormalize: denormalizeResource,
      schema: new Schema({
        resourceTypeId: resourceType.schema,
      }),
    }),
)
